{
  "FILTER": {
    "AI_PROMPT": "AI Filter",
    "TITLE": "Filter conversations",
    "SUBTITLE": "Add your filters below and hit 'Apply filters' to cut through the chat clutter.",
    "EDIT_CUSTOM_FILTER": "Edit Folder",
    "CUSTOM_VIEWS_SUBTITLE": "Add or remove filters and update your folder.",
    "ADD_NEW_FILTER": "Add filter",
    "FILTER_DELETE_ERROR": "Oops, looks like we can't save nothing! Please add at least one filter to save it.",
    "SUBMIT_BUTTON_LABEL": "Apply filters",
    "UPDATE_BUTTON_LABEL": "Update folder",
    "CANCEL_BUTTON_LABEL": "Cancel",
    "CLEAR_BUTTON_LABEL": "Clear filters",
    "FOLDER_LABEL": "Folder Name",
    "TEAMS_LABEL": "Share with",
    "PARENT_FOLDER_LABEL": "Parent folder",
    "NO_PARENT_FOLDER": "No parent folder",
    "BACKGROUND_COLOR_LABEL": "Background color",
    "COLOR_LABEL": "Color",
    "SELECT_COLOR": "Select color",
    "CLEAR_SELECTION": "Clear selection",
    "SORT_BY_LABEL": "Sort by",
    "FOLDER_QUERY_LABEL": "Folder Query",
    "EMPTY_VALUE_ERROR": "Value is required.",
    "TOOLTIP_LABEL": "Filter conversations",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "AND",
      "OR": "OR"
    },
    "INPUT_PLACEHOLDER": "Enter value",
    "OPERATOR_LABELS": {
      "equal_to": "Equal to",
      "not_equal_to": "Not equal to",
      "does_not_contain": "Does not contain",
      "is_present": "Is present",
      "is_not_present": "Is not present",
      "is_greater_than": "Is greater than",
      "is_less_than": "Is lesser than",
      "is_greater_than_or_equal": "Is greater than or equal to",
      "is_less_than_or_equal": "Is less than or equal to",
      "newer_than_days": "Is newer than x days (inclusive)",
      "older_than_days": "Is older than x days (inclusive)",
      "starts_with": "Starts with",
      "present": "Present",
      "not_present": "Not present",
      "present_with_answer": "Present with answer",
      "present_without_answer": "Present without answer",
      "equalTo": "Equal to",
      "notEqualTo": "Not equal to",
      "contains": "Contains",
      "doesNotContain": "Does not contain",
      "isPresent": "Is present",
      "isNotPresent": "Is not present",
      "isGreaterThan": "Is greater than",
      "isLessThan": "Is lesser than",
      "isGreaterThanOrEqual": "Is greater than or equal to",
      "isLessThanOrEqual": "Is less than or equal to",
      "startsWith": "Starts with"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "True",
      "FALSE": "False"
    },
    "ATTRIBUTES": {
      "STATUS": "Status",
      "ASSIGNEE_NAME": "Assignee name",
      "INBOX_NAME": "Inbox name",
      "TEAM_NAME": "Team name",
      "CONVERSATION_IDENTIFIER": "Conversation identifier",
      "CAMPAIGN_NAME": "Campaign name",
      "LABELS": "Labels",
      "BROWSER_LANGUAGE": "Browser language",
      "PRIORITY": "Priority",
      "COUNTRY_NAME": "Country name",
      "REFERER_LINK": "Referer link",
      "CUSTOM_ATTRIBUTE_LIST": "List",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Number",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Checkbox",
      "CREATED_AT": "Created at",
      "LAST_ACTIVITY": "Last activity",
      "LAST_CUSTOMER_MESSAGE_AT": "Last customer message",
      "PHONE_CALL": "Phone call",
      "RATING": "Rating",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "Inbound",
      "OUTBOUND": "Outbound",
      "MISSED": "Missed",
      "UNHANDLED_MISSED": "Unhandled missed"
    },
    "RATING_TYPES": {
      "UP": "Thumbs up",
      "DOWN": "Thumbs down"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Value is required",
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Value must be between 0 and 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standard filters",
      "ADDITIONAL_FILTERS": "Additional filters",
      "CUSTOM_ATTRIBUTES": "Custom attributes"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Do you want to save this filter?",
        "LABEL": "Name this filter",
        "PLACEHOLDER": "Name your filter to refer it later.",
        "ERROR_MESSAGE": "Name is required.",
        "SAVE_BUTTON": "Save filter",
        "CANCEL_BUTTON": "Cancel",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Folder created successfully.",
          "ERROR_MESSAGE": "Error while creating folder."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment created successfully.",
          "ERROR_MESSAGE": "Error while creating segment."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Edit folder",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Error while updating folder."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Delete filter",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Confirm deletion",
            "MESSAGE": "Are you sure to delete the filter ",
            "YES": "Yes, delete",
            "NO": "No, keep it"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Folder deleted successfully.",
          "ERROR_MESSAGE": "Error while deleting folder."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment deleted successfully.",
          "ERROR_MESSAGE": "Error while deleting segment."
        }
      }
    }
  }
}
